import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Address from "components/Address";

const contact = () => {
  return (
	<Container>
		<Row>
			<Col>
				<Address></Address>
			</Col>
		</Row>
	</Container>
  )
}

export default contact